import { getPlugintypeIdByCode } from '../functions/plugintype'
import useAuth from '../hooks/useAuth'
import { GET, POST } from '../services/api'
import { getPluginSpaceGmt } from './pluginSpaceUtils'
import { saveAs } from 'file-saver';
import XLSX from 'sheetjs-style';

type IntegrationType = {
  id: number
  name: string
  plugintemplateId: number
}

export const getCurrentMonth = () => {
  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ]
  const currentMonth = new Date().getMonth()
  return months[currentMonth]
}

export const parseJwt = (token: string) => {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}

export const getIntegrations = async () => {
  try {
    const integrationRes = await GET(`/pluginconfig`)
    const totvsIntegration = integrationRes.data.find(
      (integration: IntegrationType) =>
        integration.plugintemplateId === 23 ||
        integration.plugintemplateId === 15 ||
        integration.plugintemplateId === 45
    )
    if (
      (totvsIntegration && totvsIntegration.content && totvsIntegration.content.able === '1') ||
      totvsIntegration.plugintemplateId === 45
    ) {
      return true
    } else {
      return false
    }
  } catch (e) {
    console.log(e)
    return false
  }
}

export const usingSynkar = async () => {
  try {
    const integrationRes = await GET(`/pluginconfig`)
    const totvsIntegration = integrationRes.data.find(
      (integration: IntegrationType) =>
        integration.plugintemplateId === 108
    )
    if (totvsIntegration && totvsIntegration.content && totvsIntegration.content.able === '1') {
      return true
    } else {
      return false
    }
  } catch (e) {
    console.log(e)
    return false
  }
}

export const getGmtStore = async () => {
  try {
    // Use a função de cache em vez de chamada direta
    return await getPluginSpaceGmt()
  } catch (e) {
    return '+00:00'
  }
}

export const usingSDS = async () => {
  try {
    const integrationRes = await GET(`/pluginconfig`)
    const totvsIntegration = integrationRes.data.find(
      (integration: IntegrationType) =>
        integration.plugintemplateId === 101
    )
    if (
      (totvsIntegration && totvsIntegration.content && totvsIntegration.content.able === '1') ||
      totvsIntegration.plugintemplateId === 45
    ) {
      return true
    } else {
      return false
    }
  } catch (e) {
    console.log(e)
    return false
  }
}

export const calcPercent = (dividendo: number, divisor: number) => {
  if(divisor === 0) return 0;
  return parseFloat(((dividendo/divisor) * 100).toFixed(2))
}

export const exportExcel  = (arrayToDownload: Array<any>,name?:string) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  const ws = XLSX.utils.json_to_sheet(arrayToDownload);
  const wb = { Sheets: {data: ws}, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'})
  const data = new Blob([excelBuffer], {type: fileType})
  saveAs(data, name? name:'log_images')
}

export const exportExcelFromBuffer = (buffer: ArrayBuffer,name:string) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  const data = new Blob([buffer], { type: fileType });
  saveAs(data,name);
}

export function cpfCnpjNoMask(cpfCnpj: string) {
	let newCpf = cpfCnpj.replaceAll(".", "");
	newCpf = newCpf.replaceAll("-", "");
	newCpf = newCpf.replaceAll("/", "");
	return newCpf;
}

export function clearMask(value: string) {
  return value.replace(/\D/g, '');
}

export const formatPhoneBR = (raw?: string): string => {
  if (!raw) return ''

  // tira tudo que não é dígito
  let digits = raw.replace(/\D/g, '')

  // remove country code BR (55) se existir no começo
  if (digits.startsWith('55') && digits.length > 11) {
    digits = digits.replace(/^55/, '')
  }

  // 11 dígitos -> (DD) 9XXXX-XXXX
  if (digits.length === 11) {
    const ddd = digits.slice(0, 2)
    const part1 = digits.slice(2, 7) // 5 primeiros do número
    const part2 = digits.slice(7)    // 4 últimos
    return `(${ddd}) ${part1}-${part2}`
  }

  // 10 dígitos -> (DD) XXXX-XXXX
  if (digits.length === 10) {
    const ddd = digits.slice(0, 2)
    const part1 = digits.slice(2, 6)
    const part2 = digits.slice(6)
    return `(${ddd}) ${part1}-${part2}`
  }

  // 9 dígitos -> 9XXXX-XXXX (sem DDD) — raro, mas coberto
  if (digits.length === 9) {
    const part1 = digits.slice(0, 5)
    const part2 = digits.slice(5)
    return `${part1}-${part2}`
  }

  // 8 dígitos -> XXXX-XXXX
  if (digits.length === 8) {
    return `${digits.slice(0, 4)}-${digits.slice(4)}`
  }

  // fallback: devolve só os dígitos (ou você pode escolher retornar raw)
  return digits
}


